// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/handsontable/src/plugins/comments/comments.css
// module id = 469
// module chunks = 0